<template>
<v-card :flat='flat' >
    <note-list
      :with-add='false'
      :client='clientObject'
      :appointment='appointment'
      v-model='appointment' >
    </note-list>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click='openGlobalDialog(true, "Notes", {appointment:appointment})' flat >
        <v-icon>add</v-icon> Add a note
      </v-btn>
    </v-card-actions>
</v-card>
</template>
<script>
import NoteList from '@/components/NoteList'

export default {
  name: 'NotesTab',
  components: {NoteList},
  props: {
    value: { type: Object, required: true },
    touch: { type: Number, default: 0 },
    flat: { type: Boolean, default: true }
  },
  data () {
    return {
      appointment: false,
      sendMessageDialog: false,
      loading: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.appointment = this.value }
      }
    }
  },
  computed: {
    clientObject () {
      // this returns a _user_ (e.g.: client.client)
      if (isNaN(this.appointment.client)) {
        if (this.appointment && this.appointment.client) {
          let obj = this.appointment.client
          obj.client = { id: obj.id }
          return obj
        }
      } else {
        let cli = this.clients.find((client) => {
          return this.appointment.client === client.client.id
        })
        // so many layers like an onion
        if (cli && cli.client) {
          let obj = cli.client
          obj.client = { id: cli.client.id }
          return obj
        }
        return {}
      }
    },
    clients () {
      return this.$store.getters.clients
    }
  }
}
</script>



// WEBPACK FOOTER //
// NotesTab.vue?042fc3c0